import { Box, getColoursFromTheme, Stack } from 'src/viewLayer/components/DesignSystem'
import devices from 'src/viewLayer/styling/mixins/mediaQueries'
import styled from 'styled-components'

const LoginEmailPageContainer = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  height: 100%;
  min-height: calc(100% - 4rem);
  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`

const FormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`

const ActionsContainer = styled(Box)`
  display: block;
  margin: 2.125rem auto 0;
  width: 100%;
`

const InputFrame = styled(Box)`
  padding: 2.375rem 0 0 0;

  @media only screen and ${devices.fromsmall} {
    padding: 2rem 0 0 0;
  }
`
export { ActionsContainer, FormContainer, InputFrame, LoginEmailPageContainer }
